import API_PATH from '../../../config/API_PATH'
import { NOTIFICATIONS, NOTIFICATIONS_HIDE, NOTIFICATIONS_UNREAD_COUNT } from './contants'

export const geNotifications = data => {
	return {
		type: NOTIFICATIONS,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.notifications,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const geNotificationsUnreadCount = data => {
	return {
		type: NOTIFICATIONS_UNREAD_COUNT,
		data,
		meta: {
			method: 'GET',
			url: API_PATH.notificationsunreadCount,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
export const geNotificationsHide = data => {
	return {
		type: NOTIFICATIONS_HIDE,
		data,
		meta: {
			method: 'POST',
			url: API_PATH.notificationHide,
			query: data.query || {},
			callback: data.callback || null
		},
	}
}
